<template>
  <div class="ChangePassword">
    <div class="list">
      <div class="item">
        <input type="text" placeholder="填写姓名" v-model="real_name" />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>姓别</div>
        <div class="item-right">
          <label class="item-right-text" @click="sextype(0)">
            <span
              :class="'radio ' + (sexcheck == 0 ? 'checked iconfont' : '')"
            ></span
            >男
          </label>
          <label class="item-right-text" @click="sextype(1)">
            <span
              :class="'radio ' + (sexcheck == 1 ? 'checked iconfont' : '')"
            ></span
            >女
          </label>
        </div>
      </div>
      <div class="item  acea-row row-between-wrapper">
        <div>生日</div>
        <div class="item-right" style="width: 80%;height: 100%;">
          <!-- <input
            type="text"
            placeholder="填写生日"
            v-model="birthday"
            style="text-align:right;"
          /> -->
          <el-date-picker
            v-model="value1"
            type="date"
            placeholder="选择日期"
            style="height: 100%;"
            :align="center"
            :editable="false"
          >
          </el-date-picker>
        </div>
      </div>
      <!-- 			<div class="item">
				<input type="text" placeholder="填写年龄" v-model="age" />
			</div> -->
      <div class="item">
        <input
          type="number"
          placeholder="填写手机号码"
          v-model="phone"
          style="height: 100%!important;text-align: left!important;"
        />
      </div>
      <div class="item acea-row row-between-wrapper">
        <input
          type="text"
          placeholder="填写验证码"
          class="codeIput"
          v-model="captcha"
          style="text-align: left!important;"
        />
        <button
          class="code font-color-red"
          :disabled="disabled"
          :class="disabled === true ? 'on' : ''"
          @click="code"
        >
          {{ text }}
        </button>
      </div>
    </div>
    <div class="confirmBnt bg-color-red" @click="confirm">确认绑定</div>
    <div class="ewm" v-if="ewm_show">
      <img
        src="http://wx.dxkyyy.com/uploads/merchant/img/20200609/20200609/s_333feabcddca90aa42d337efc27cbd6c.jpg"
        alt=""
      />
      <div class="text">扫描二维码关注公众号</div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import sendVerifyCode from "@mixins/SendVerifyCode";
import { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { registerVerify, bindingPhone } from "@api/user";
import { getUser } from "../../api/user";

export default {
  name: "BindingPhone",
  components: {},
  data: function() {
    let tdata = [];
    for (let i = 0; i < 20; i++) {
      tdata.push({
        label: `第${i}行`,
        value: i
      });
    }
    return {
      pickData: [tdata],
      captcha: "",
      userInfo: "",
      real_name: "",
      phone: "", //手机号
      birthday: "",
      sexcheck: 0,
      value1: "",
      age: "",
      ewm_show: false,
      pickerVisible: false,
      result: ""
    };
  },
  mixins: [sendVerifyCode],
  computed: mapGetters(["userInfo"]),
  mounted: function() {
    let that = this;
    that.User();
  },
  watch: {
    userInfo: function() {
      let that = this;
      if (that.userInfo.phone !== null) {
        console.log(that.userInfo.phone);
        // that.$router.replace({ name: "User" });
      } else {
      }
    }
  },
  methods: {
    confirm2222() {
      this.pickerVisible = true;
    },
    cancel() {
      console.log("cancel");
      this.result = "click cancel result: null";
    },
    confirm(res) {
      this.result = JSON.stringify(res);
      console.log(res);
    },
    sextype: function(type) {
      this.sexcheck = type;
      this.userInfo["xb"] = type;
    },
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
      });
    },
    async confirm() {
      let that = this;
      const { phone, captcha, real_name } = that;
      try {
        await that
          .$validator({
            phone: [
              chs_phone(chs_phone.message("手机号码")),
              alpha_num(alpha_num.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ]
          })
          .validate({
            phone,
            captcha
          });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      bindingPhone({
        phone: this.phone,
        uid: that.userInfo.uid,
        birthday: that.value1,
        xb: that.sexcheck,
        age: that.age,
        real_name: this.real_name,
        captcha: this.captcha
      })
        .then(res => {
          console.log(res);
          that.$dialog.success(res.msg).then(() => {
            window.location.href = "/guanzhu.html";
          });
          // return false;
          // this.$router.push({path: "/user"});
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async code() {
      let that = this;
      const { phone } = that;
      try {
        await that
          .$validator({
            phone: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({
            phone
          });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      registerVerify({
        phone: phone
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    }
  }
};
</script>
<style>
.el-picker-panel,
.el-date-picker,
.el-popper {
  position: absolute;
  top: 190px;
  left: 0 !important;
  right: 0 !important;
  z-index: 2001;
  margin: auto !important;
}
.ChangePassword .list .item input {
  /* height: auto !important; */
  border: none !important;
  text-align: center !important;
}
.el-input__prefix {
  opacity: 0 !important;
}
.ewm {
  width: 6rem;
  padding: 0.5rem 0;
  text-align: center;
  background: #ffffff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 1rem;
  left: 50%;
  margin-left: -3rem;
  border-radius: 10px;
  z-index: 9;
}

.ewm .text {
  margin-top: 20px;
}
.item-right-text .radio {
  width: 15px;
  height: 15px;
  display: inline-block;
  border: 1px solid #07c04d;
  vertical-align: sub;
  margin-right: 5px;
  margin-left: 10px;
}

.item-right-text .radio.checked {
  position: relative;
  background-color: #07c04d;
  border-color: #07c04d;
}

.item-right-text .radio.checked:before {
  /* font: normal normal normal 14px/1; */
  content: "\E8CA";
  color: #fff;
  font-size: 15px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -48%) scale(0.73);
  -webkit-transform: translate(-50%, -48%) scale(0.73);
}
</style>
